import { z } from "zod";
import { isoDateSchema, objectIdSchema } from "./common";
export const campaignStatusEnum = z.enum([
    "DRAFT",
    "SCHEDULED",
    "RUNNING",
    "PAUSED",
    "COMPLETED",
    "CANCELLED",
]);
export const campaignCountsSchema = z.object({
    queued: z.number().int().min(0),
    sent: z.number().int().min(0),
    delivered: z.number().int().min(0),
    failed: z.number().int().min(0),
});
export const campaignSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    templateId: objectIdSchema,
    groupId: objectIdSchema,
    scheduledAt: isoDateSchema.nullable(),
    status: campaignStatusEnum,
    counts: campaignCountsSchema,
    createdAt: isoDateSchema,
});
export const createCampaignSchema = z.object({
    templateId: objectIdSchema,
    groupId: objectIdSchema,
    scheduledAt: isoDateSchema.optional(),
});
//# sourceMappingURL=campaign.js.map